import { lazy } from 'react';
import { registerModuleRoute } from 'app/navigation/routeRegistry';
import { ModuleRoute } from 'app/navigation/routeRegistry';
import { CHAT_SCREEN_NAMES } from './navigation/ChatNavigation';
import { ChatTabIcon } from './components';

const ChatNavigation = lazy(() => import('./navigation/ChatNavigation'));
const chatRoutes: ModuleRoute = {
    id: 'chat',
    Stack: ChatNavigation,
    meta: {
        placement: 'tab',
        tabLabel: 'Chat',
        tabIcon: ChatTabIcon,
        order: 30,
    },
    screenNames: CHAT_SCREEN_NAMES,
};


registerModuleRoute(chatRoutes);

export * from './hooks';